import { render } from "./examen_invoice.vue?vue&type=template&id=3267bf8c"
import script from "./examen_invoice.vue?vue&type=script&lang=js"
export * from "./examen_invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__